
export const default_avatar = require('../static/images/default_avatar.png')

export const default_unnoticed = require("../static/images/unnotic.png")



